import {useEffect, useMemo, useRef} from 'react';
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {roleActions} from "_actions";
import {excludeByKey} from "../../../UserManagement/Utilities/UserInviteUtils";

export default function useRolesFetch () {
    const dispatch = useDispatch();
    const effectRan = useRef(false);

    useEffect(() => {
        if(effectRan.current === false) {
            dispatch(roleActions.getAll());
            return () => effectRan.current = true;
        }
    }, []);

    const rolesObj = useSelector(state => state.roles.roles);
    const loading = useSelector(state => state.roles.loading);
    const roleObjList = _.get(rolesObj, 'roles') || []

    const roles = useMemo(() => {
        const roleArr = [];
        if(!loading && roleObjList.length > 0) {
            roleObjList.map( role => {
                const roleObj = {};
                roleObj.id = role?.id;
                roleObj.name = role?.authority;
                roleArr.push(roleObj);
            });
        }
        const excludedRoles = ["ROLE_CHATDESK_ANALYST", "BILLING_ADMIN_ROLE", "ROLE_COMPANY_USER", "ROLE_CHATDESK_REVIEWER"];
        return excludeByKey(roleArr, "name", excludedRoles);
    }, [ roleObjList ]) || [];

    return {roles, loading}
}